import { BuildingApi } from '@wiz-api/personnel-position'
import { PersonnelLocationApi } from '@wiz-api/huizhou2'
import { map, get, find, concat, isEmpty, isEqual, cloneDeep, throttle } from 'lodash'
import { Message } from 'element-ui'

const buildingApi = new BuildingApi()
const personnelLocationApi = new PersonnelLocationApi()

/** ************************************************ 建筑列表 **************************************** */
// 建筑列表
let buildingList = []
// 建筑图标列表
let buildingIconList = []
// 在线人员列表
let allLineList = []
let socketLineList = []
let socketObject
let updateTimer
let cloudRender
let drawHandler
let sceneId
// 标签定位位置类型
const markPosType = {
  leftTop: 0,
  midTop: 1,
  rightTop: 2,
  leftBottom: 3,
  midBottom: 4,
  rightBottom: 5,
}

// 初始化数据
const initData = () => {
  buildingList = []
  buildingIconList = []
  allLineList = []
  socketLineList = []
  if (updateTimer) {
    clearInterval(updateTimer)
    updateTimer = null
  }
  if (socketObject) {
    socketObject.close()
    socketObject = null
  }
  drawHandler = null
}

// 打开建筑详情
const openBuildingDetail = (buildingId) => {
  if (!buildingId) {
    return
  }
  const openEvent = new CustomEvent('openComponent', {
    detail: {
      toCom: {
        code: 'BuildingOperation',
        origin: 'tag',
        name: '建筑操作',
        originTagName: 'BuildingList',
      },
      type: 'tags',
      props: {
        buildingId,
      },
    },
  })
  window.dispatchEvent(openEvent)
}

// 获取建筑列表
const getBuildingList = async (sceneId) => {
  const [err, res] = await buildingApi.getList({
    sceneId,
    skipCount: 0,
    maxResultCount: 1000,
  })
  if (!err && res) {
    return res.items
  }
  return []
}

// 绘制标签
const drawMarker = async (player, buildingDetail) => {
  if (!player.Native) return
  const points = JSON.parse(buildingDetail.coordinate)
  const posArr = [points[0].x, points[0].y, points[0].z]
  const singleOption = {
    id: getUUID(),
    pos: posArr,
    background: 'buildFloor',
    visible: true,
    nodeOffset: [0, 0],
    text: `${buildingDetail.name} ${buildingDetail.count || 0}人`,
    textColor: '#ffff00ff',
    hasTriangle: true,
    markPosType: markPosType.midBottom,
  }
  // 文字
  const res = await cloudRender.Marker.createBySingleLine(singleOption)
  if (res.status) {
    const data = map(res.data, (item) => {
      return {
        id: item,
        buildingId: buildingDetail.id,
      }
    })
    buildingIconList = concat(buildingIconList, data)
  }
}

// 生成UUID
const getUUID = () => {
  const tempUrl = URL.createObjectURL(new Blob())
  const uuid = tempUrl.toString()
  URL.revokeObjectURL(tempUrl)
  return uuid.substring(uuid.lastIndexOf('/') + 1)
}

// 标签事件
const markerClick = (e) => {
  // 左键点击并且有id
  if (e.type === 1 && !isEmpty(e.markerId)) {
    const buildingInfo = find(buildingIconList, (item) => {
      return item.id === e.markerId
    })
    if (buildingInfo) {
      // 移动到视角
      openBuildingDetail(get(buildingInfo, 'buildingId'))
    }
  }
}

// 获取建筑人数
const updateBuildingCount = async () => {
  if (isEmpty(socketLineList)) {
    return []
  }
  const [err, res] = await personnelLocationApi.getFloorPersonCount({
    body: {
      modelId: sceneId,
      onLineList: socketLineList
    }
  })
  if (!err) {
    return res
  }
  return []
}
// 创建节流函数
const updateBuildingMarkers = throttle(async (cloudRender, buildingIconList) => {
  const resData = await updateBuildingCount()
  map(resData, (item) => {
    const icon = find(buildingIconList, { buildingId: item.id })
    if (icon) {
      cloudRender.Marker.updateBySingleLine({
        id: icon.id,
        text: `${item.name} ${item.count}人`,
      })
    }
  })
}, 7000, { trailing: false })

const connectSocket = () => {
  const socketPath =
    get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
      ?.PersonnelPositionPath || ''
  if (!socketPath) {
    Message.warning('未配置websocket地址')
    return
  }
  const socketUrl = `${socketPath}/Position?modelId=${sceneId}&siteId=3a0743fd-2f61-51c2-3bfd-415e973ef230`
  socketObject = new WebSocket(socketUrl)
  socketObject.onmessage = async ({ data }) => {
    if (data.indexOf('连接成功') === 0) {
      // console.log('连接成功!')
    } else {
      const res = cloneDeep(JSON.parse(data))
      const oldSocketLineList = [...socketLineList] // 保存旧数据的副本
      let hasChanges = false
      if (res.onLineList.length !== 0) {
        allLineList = res.onLineList
        socketLineList = allLineList
        hasChanges = true
      } else if (res.positionList.length !== 0) {
        const positionMap = new Map(
          res.positionList.map((pos) => {
            return [
              pos.tagId,
              pos
            ]
          })
        )
        // 更新位置信息
        socketLineList = socketLineList.map((socketItem) => {
          const matchedPosition = positionMap.get(socketItem.tagId)
          if (matchedPosition) {
            return {
              ...socketItem,
              x: matchedPosition.x,
              y: matchedPosition.y,
              z: matchedPosition.z
            }
          }

          return socketItem
        })
        hasChanges = socketLineList.some((item, index) => {
          return item.x !== oldSocketLineList[index].x ||
            item.y !== oldSocketLineList[index].y ||
            item.z !== oldSocketLineList[index].z
        })
      }
      // 只有在数据发生变化时才更新建筑人数
      if (hasChanges) {
        updateBuildingMarkers(cloudRender, buildingIconList)
      }
    }
  }
}


// 创建建筑
const create = async (player, sourceId, propCloudRender) => {
  if (!player.Native) {
    return
  }
  sceneId = sourceId
  // 初始化数据
  initData()
  cloudRender = propCloudRender
  cloudRender.Dispatch.on('Marker', markerClick)
  drawHandler = new Promise(async (resolve) => {
    // 获取建筑列表数据
    buildingList = await getBuildingList(sourceId)
    const countList = await updateBuildingCount()
    countList.forEach((item) => {
      const building = find(buildingList, { id: item.id })
      if (building) {
        building.count = item.count
      }
    })
    // 生成建筑
    await Promise.all(
      map(buildingList, (item) => {
        return drawMarker(player, item)
      })
    )
    resolve()
  })
  connectSocket()
}

// 销毁建筑
const destroy = async (player) => {
  if (!player.Native) {
    return
  }
  if (updateTimer) {
    clearInterval(updateTimer)
    updateTimer = null
  }
  if (socketObject) {
    socketObject.close()
    socketObject = null
  }
  socketLineList = []
  allLineList = []
  await drawHandler
  if (!get(cloudRender, 'Marker')) return
  // 销毁图标
  cloudRender.Marker.destroyMarker(map(buildingIconList, 'id'))
  // 取消标签的事件监听
  cloudRender.Dispatch.off('Marker', markerClick)
}

// 切换标签显示隐藏
const toggleDisplay = async (type) => {
  await drawHandler
  await cloudRender.Marker.updateBySingleLine(
    map(buildingIconList, (item) => {
      return {
        id: item.id,
        visible: type,
      }
    })
  )
}

// 隐藏标签
const hidden = async () => {
  await toggleDisplay(false)
}

// 重新显示标签
const display = async () => {
  await toggleDisplay(true)
}

export default { create, destroy, hidden, display }
